<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('payments')"
      :columns="columns"
      :column_search="false"
      resource_url="/loan/payment/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create_payment">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <payment-modal ref="payment_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import PaymentModal from "./payment_modal/Index.vue";

export default {
  name: "PaymentDataTable",
  components: { GenericTable, PaymentModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("payment date"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${format_date(
              row.payment_date
            )}</div>
            <div class="subtitle is-6">${v.$t(row.payment_method)}</div>`;
          },
        },
        {
          title: v.$t("loan"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.loan?.loan_number || ""}</div>
            <div class="subtitle is-6">${
              row.loan?.customer?.first_name || ""
            } ${row.loan?.customer?.last_name || ""}</div>`;
          },
        },
        {
          title: v.$t("amounts"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${format_currency(row.amount)}</div>
            <div class="subtitle is-7">
              ${v.$t("principal")}: ${format_currency(row.principal_amount)}<br>
              ${v.$t("interest")}: ${format_currency(row.interest_amount)} <br>
              ${v.$t("late fee")}: ${format_currency(row.late_fee_amount)}
            </div>`;
          },
        },
        {
          title: v.$t("reference"),
          searchable: true,
          data: (row) => {
            return row.reference_number || "-";
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_payment(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure delete payment"),
                    v,
                    () => {
                      del("/loan/payment", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_payment() {
      this.$refs.payment_modal.show_modal();
    },
    edit_payment(uuid) {
      this.$refs.payment_modal.show_modal(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
